<template>
  <auth-shell title="استعادة كلمة المرور" :subtitle="step == 0 ? 'اكتب رقم الجوال المسجل، وسيصلك كود الاستعادة على الواتساب.' : 'اكتب الكود الذي وصلك وكلمة المرور الجديدة.'">
    <div class="auth-steps" aria-hidden="true">
      <span class="on"></span>
      <span :class="{ on: step == 1 }"></span>
    </div>
    <div class="auth-alert bad" v-if="error"><i class="fa fa-exclamation-circle"></i><span>{{ error }}</span></div>
    <div class="auth-alert ok" v-if="success"><i class="fa fa-check-circle"></i><span>{{ success }}</span></div>

    <div v-if="step == 0">
      <label class="auth-field" for="reset-phone">
        <span class="auth-label">رقم الجوال</span>
        <span class="auth-input">
          <i class="fa fa-mobile"></i>
          <input id="reset-phone" type="text" inputmode="tel" v-model="phone" v-on:keyup.enter="step1()" placeholder="05xxxxxxxx">
        </span>
      </label>
      <button class="auth-btn" @click="step1()">
        إرسال كود الاستعادة <i class="fa fa-arrow-left"></i>
      </button>
    </div>

    <div v-if="step == 1">
      <label class="auth-field" for="reset-code">
        <span class="auth-label">كود الاستعادة</span>
        <span class="auth-input code">
          <input id="reset-code" type="text" inputmode="numeric" autocomplete="one-time-code" v-model="code" placeholder="••••">
        </span>
      </label>
      <label class="auth-field" for="reset-password">
        <span class="auth-label">كلمة المرور الجديدة</span>
        <span class="auth-input">
          <i class="fa fa-lock"></i>
          <input id="reset-password" :type="show ? 'text' : 'password'" v-model="password" v-on:keyup.enter="step2()" autocomplete="new-password" placeholder="كلمة المرور الجديدة">
          <button type="button" class="auth-eye" @click="show = !show" :aria-label="show ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'">
            <i :class="show ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
        </span>
      </label>
      <button class="auth-btn" @click="step2()">
        تغيير كلمة المرور <i class="fa fa-check"></i>
      </button>
    </div>

    <p class="auth-alt">
      تذكرت كلمة المرور؟
      <a href="javascript:;" @click="$router.push('/login')">تسجيل الدخول</a>
    </p>
  </auth-shell>
</template>

<script>
import AuthShell from '../components/AuthShell.vue';

export default {
    components: { AuthShell },
    created(){

    },
    data(){
        return {
            phone: "",
            step: 0,
            error: "",
            success: "",
            code: "",
            password: "",
            show: true
        }
    },
    methods: {
        step1(){
            var g = this;
            g.error = null;
            $.post(api + '/user/auth/reset', {
                phone: this.phone
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    g.step = 1
                    g.success = r.response
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        },
        step2(){
            var g = this;
            g.error = null;
            $.post(api + '/user/auth/reset_confirm', {
                phone: this.phone,
                code: this.code,
                password: this.password
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    g.success = r.response
                    window.location = '/'
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        },
    }
}
</script>
